import { BrowserModule } from "@angular/platform-browser";//
import { NgModule } from "@angular/core"; //
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormsModule, ReactiveFormsModule } from "@angular/forms"; //
import { ModalModule } from "ngx-bootstrap/modal";
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatSelectModule } from "@angular/material/select";
import { MglTimelineModule } from "angular-mgl-timeline";
import { MatSliderModule } from '@angular/material/slider';
import {MatSlideToggleModule } from '@angular/material/slide-toggle';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTableModule} from '@angular/material';

import {MatSortModule} from '@angular/material';
import {MatExpansionModule} from '@angular/material/expansion';
//para tabla
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatInputModule} from '@angular/material/input';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import {MatNativeDateModule} from '@angular/material/core';
import {HttpClientModule} from '@angular/common/http';

//componentes
import { ReporteComponent } from './reporte/reporte.component';
import { HomeComponent } from "./home/home.component";
import { MenureporteComponent } from './menureporte/menureporte.component';
import { CrearEncuestaComponent } from './crear-encuesta/crear-encuesta.component';
import { RegistroComponent } from './registro/registro.component';
import { PrincipalComponent } from './principal/principal.component';
import { LoginComponent } from './login/login.component';
import { AdminComponent } from './admin/admin.component';
import { RegistroProfesoresComponent } from './registro-profesores/registro-profesores.component';
import { CRUDusuarioComponent } from './crudusuario/crudusuario.component';
import { ModuloDocenteComponent } from './modulo-docente/modulo-docente.component';
import { ModuloEstudianteComponent } from './modulo-estudiante/modulo-estudiante.component';
import { FilterPipe } from './pipes/filter.pipe';
import { EncuestasLibresComponent } from './encuestas-libres/encuestas-libres.component';
import { ModuloCoordinadorComponent } from './modulo-coordinador/modulo-coordinador.component';
import { ModuloDirectorComponent } from './modulo-director/modulo-director.component';



@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ReporteComponent,
    MenureporteComponent,
    CrearEncuestaComponent,
    RegistroComponent,
    PrincipalComponent,
    LoginComponent,
    AdminComponent,
    RegistroProfesoresComponent,
    CRUDusuarioComponent,
    ModuloDocenteComponent,
    ModuloEstudianteComponent,
    FilterPipe,
    EncuestasLibresComponent,
    ModuloCoordinadorComponent,
    ModuloDirectorComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    MatSelectModule,
    MglTimelineModule,
    CommonModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatExpansionModule,
    MatNativeDateModule,
    HttpClientModule,
    MatPaginatorModule,
    MatInputModule,
    MatMenuModule,
    MatTableModule,
    MatSortModule,
    MatIconModule,
    ModalModule.forRoot(),
    AccordionModule.forRoot(),
  ],
  providers: [],
  bootstrap: [AppComponent],

})
export class AppModule {}
